export default __webpack_public_path__ + "static/media/solution.e2753922.png";